var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2472 12.4805C14.3139 12.4805 13.5806 13.2305 13.5806 14.1471C13.5806 15.0638 14.3306 15.8138 15.2472 15.8138C16.1639 15.8138 16.9138 15.0638 16.9138 14.1471C16.9138 13.2305 16.1639 12.4805 15.2472 12.4805Z",
    fill: "#A60A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7668 8.4C34.3668 5.15 31.2835 3.33333 26.9835 3.33333H13.0168C7.66683 3.33333 3.3335 7.66667 3.3335 13.0167V26.9833C3.3335 31.2833 5.15016 34.3667 8.40016 35.7667C8.71683 35.9 9.0835 35.8167 9.31683 35.5833L35.5835 9.31667C35.8335 9.06667 35.9168 8.7 35.7668 8.4ZM17.5502 20.4C16.9002 21.0333 16.0502 21.3333 15.2002 21.3333C14.3502 21.3333 13.5002 21.0167 12.8502 20.4C11.1502 18.8 9.2835 16.25 10.0002 13.2167C10.6335 10.4667 13.0668 9.23333 15.2002 9.23333C17.3335 9.23333 19.7668 10.4667 20.4002 13.2333C21.1002 16.25 19.2335 18.8 17.5502 20.4Z",
    fill: "#A60A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4482 34.2158C32.8148 34.5825 32.7648 35.1825 32.3148 35.4325C30.8482 36.2492 29.0648 36.6658 26.9815 36.6658H13.0149C12.5315 36.6658 12.3315 36.0992 12.6649 35.7658L22.7315 25.6992C23.0648 25.3658 23.5815 25.3658 23.9148 25.6992L32.4482 34.2158Z",
    fill: "#A60A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6694 13.0149V26.9815C36.6694 29.0648 36.2527 30.8648 35.436 32.3148C35.186 32.7648 34.586 32.7982 34.2194 32.4482L25.686 23.9148C25.3527 23.5815 25.3527 23.0648 25.686 22.7315L35.7527 12.6649C36.1027 12.3315 36.6694 12.5315 36.6694 13.0149Z",
    fill: "#A60A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapic);
export default __webpack_public_path__ + "static/media/mapic.0db2cfd9e65b6f6d4ebfcb5340cdd53d.svg";
export { ForwardRef as ReactComponent };